import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { getMinePosts } from "../../../../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import LabelgetRemaindays from "../../../../../Common/CustomeLabel/LabelgetRemaindays";
import CustomeDeadlineDateLabel from "../../../../../Common/CustomeLabel/CustomeDeadlineDateLabel";
import { useRouteBaseStateContext } from "../../../../../../Context/RouteBaseStateContext";

export default function PostedContests() {
  const { setManageActivecontestroute, setMyAllContestListroute } = useRouteBaseStateContext();
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  const postlistmine = useSelector(
    ({ posts: { postlistmine } }) => postlistmine,
  );

  useEffect(() => {
    dispatch(getMinePosts(2));
  }, [dispatch]);

  // Filter arrays based on status
  const resentpostedContests = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => item.status == 10)
    : [];
  const activeContests = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => (item.status == 11 || item.status == 12))
    : [];
  const completedContests = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => item.status == 12)
    : [];

  return (
    <>
      <div className="posted-project">
        <div className="d-flex justify-content-between align-items-center">
          <h4>Payment Pending Contest ({resentpostedContests.length})</h4>
          <button className="buttons background-button"
            onClick={() => {
              navigate(`/${lan}/dashboard/myorders/contest/listings`)
              setMyAllContestListroute('paymentpendingcontest')
            }
            }
          >
            View More
          </button>
        </div>
        <div className="recent-post">
          {resentpostedContests.length == 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            resentpostedContests.slice(0, 4).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-5 ">
                  <h3>{item?.title}</h3>
                  <div className="post-img">
                    <CustomeDeadlineDateLabel
                      type={item?.type}
                      last_date={item?.last_date}
                    />
                    <LabelgetRemaindays last_date={item?.last_date} />
                  </div>
                </div>
                <div className="activity col-md-4">
                  <h6>Activity</h6>
                  <div className="post-img">
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                        alt=""
                      />
                      Entries: {item?.proposal_count}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/${lan}/dashboard/myorders/contest/active/${item.id}`,
                    );
                  }}
                  className="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            ))
          )}
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <h4>All Active Win business Opportunities (WBO) ({activeContests.length})</h4>
          <button className="buttons background-button"
            onClick={() => {
              navigate(`/${lan}/dashboard/myorders/contest/listings`)
              setMyAllContestListroute('activeconstest')
            }
            }
          >
            View More
          </button>
        </div>
        <div className="recent-post">
          {activeContests.length === 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            activeContests.slice(0, 4).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-5 ">
                  <h3>{item?.title}</h3>
                  <div className="post-img">
                    <CustomeDeadlineDateLabel
                      type={item?.type}
                      last_date={item?.last_date}
                    />
                    <LabelgetRemaindays last_date={item?.last_date} />
                  </div>
                </div>
                <div className="activity col-md-4">
                  <h6>Activity</h6>
                  <div className="post-img">
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                        alt=""
                      />
                      Entries: {item?.proposal_count}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/${lan}/dashboard/myorders/contest/active/${item.id}`,
                    );
                    setManageActivecontestroute("");
                  }}
                  className="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
